import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { setUserGroups, saveUser } from 'modules/users';
import { register as registerAction } from 'helpers/accountsHelpers';
import { withZones } from '../../Zones';
import render from './render';

export class UserForm extends React.Component {
  static propTypes = {
    render: PropTypes.func,
    user: PropTypes.object,
    onSubmit: PropTypes.func,
  };

  static defaultProps = {
    render,
    onSubmit () {},
  };

  state = {
    pristine: true,
    saving: false,
    errorMatricule: false,
    errorGroup: false,
    success: false,

    matricule: undefined,
    group: undefined,
  };

  componentDidMount () {
    this.props.user && this.setState({ matricule: this.props.user.uuid });
  }

  componentDidUpdate ({ user: { uuid: prevUuid } = {} }) {
    const { user: { uuid } = {} } = this.props;

    if (uuid !== prevUuid) {
      this.resetMatricule();
    }
  }

  componentWillUnmount () {
    this.isCancelled = true;
  }

  setEmail = email => this.setState({ email });

  setUser = ({ id }) => {
    const { history: { push }, match: { path } } = this.props;
    push(path.replace(/:id/, id));
  };

  setGroup = group => this.setState({ group, success: false, errorGroup: false, pristine: false });

  setMatricule = ({ target: { value: matricule } }) =>
    this.setState({ matricule, success: false, errorMatricule: false, pristine: false });

  save = async e => {
    e.preventDefault();

    const { user, user: { id, groups } } = this.props;
    const { matricule, group } = this.state;

    const todo = [];

    if (matricule && user.uuid !== matricule) {
      todo.push(this.saveMatricule(matricule));
    }

    if (group && !groups.includes(group)) {
      todo.push(this.saveUserGroups(id, ['staff', group]));
    }

    this.setState({ saving: true, success: false, errorMatricule: false, errorGroup: false });
    await Promise.all(todo);

    if (this.isCancelled) return;

    this.setState({ saving: false });
  }

  register = async () => {
    this.setState({ registering: true });
    const { history: { replace }, match: { path } } = this.props;
    const { email } = this.state;
    const user = await registerAction(email);
    this.props.setUserGroups(user.id, ['staff', 'N1']);
    replace(path.replace(/:id/, user.id));
  }

  async saveUserGroups (id, groups) {
    const { error = false } = await this.props.setUserGroups(id, groups);
    if (error) {
      this.setState({ errorGroup: !!error });
      return;
    }
    this.setState({ success: true });
  }

  resetMatricule () {
    const { user: { uuid } = {} } = this.props;
    this.setState({ matricule: uuid });
  }

  async saveMatricule (matricule) {
    const { user, user: { uuid: prevUUID }, changeZoneOwner } = this.props;
    user.uuid = matricule;
    user.properties.CCOD_PST = matricule;

    const { error = false } = await this.props.saveUser(user);
    if (error) {
      user.uuid = prevUUID;
      user.properties.CCOD_PST = prevUUID;
      this.setState({ matricule: prevUUID, errorMatricule: !!error });
      return;
    }
    changeZoneOwner(prevUUID, matricule);
    this.setState({ success: true });
  }

  render () {
    const { render: Render, user, ...nextProps } = this.props;
    const { setMatricule, save, setGroup, setUser, setEmail, register } = this;
    const {
      saving,
      email,
      registering,
      matricule,
      errorMatricule,
      errorGroup,
      success,
      pristine,
    } = this.state;
    const group = (user.groups && user.groups.includes('staff')) && (user.groups.includes('N1')
      ? 'N1'
      : 'N2');
    const { email: userEmail } = user;
    const { properties: { structure: { name = userEmail } = {} } = {} } = user || {};
    const props = {
      ...nextProps,
      user,
      name,
      group,
      matricule,
      setUser,
      setGroup,
      setMatricule,
      save,
      saving,
      email,
      setEmail,
      register,
      registering,
      errorMatricule,
      errorGroup,
      success,
      pristine,
    };

    return <Render {...props} />;
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  setUserGroups,
  saveUser,
}, dispatch);

export default connect(null, mapDispatchToProps)(withRouter(withZones(UserForm)));



// WEBPACK FOOTER //
// ./src/components/Admin/UsersManagement/UserEdit/Form/index.js